export class PaymentOperation {
    public orderId: string;
    public transactionId: string;
    public authorizationId: string;
    public clientCode: string;
    public clientName: string;
    public payDate: Date;
    public currencySymbol: string;
    public cardType: string;
    public breadCard: string;
    public total: number;
    public paymentBillItemList: Array<any> = [];
    public selectionsRows: Array<any> = [];
    public name: string;
    public lastname: string;
}

export class PaymentItems {
    public orderId: string;
    public transactionId: string;
    public acceptCommerce: boolean;
    public clientCode: string;
    public interlocutorId: string

}
